/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { OutDealDTO } from "./OutDealDTO";
import { OutDealDTOFromJSON, OutDealDTOFromJSONTyped, OutDealDTOToJSON } from "./OutDealDTO";
import type { UserRoleDTO } from "./UserRoleDTO";
import { UserRoleDTOFromJSON, UserRoleDTOFromJSONTyped, UserRoleDTOToJSON } from "./UserRoleDTO";

/**
 *
 * @export
 * @interface OutPublicUserWithDealsDTO
 */
export interface OutPublicUserWithDealsDTO {
  /**
   *
   * @type {UserRoleDTO}
   * @memberof OutPublicUserWithDealsDTO
   */
  role: UserRoleDTO;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDealsDTO
   */
  company?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDealsDTO
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDealsDTO
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDealsDTO
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof OutPublicUserWithDealsDTO
   */
  phone?: string;
  /**
   *
   * @type {number}
   * @memberof OutPublicUserWithDealsDTO
   */
  id: number;
  /**
   *
   * @type {Array<OutDealDTO>}
   * @memberof OutPublicUserWithDealsDTO
   */
  deals: Array<OutDealDTO>;
}

/**
 * Check if a given object implements the OutPublicUserWithDealsDTO interface.
 */
export function instanceOfOutPublicUserWithDealsDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "role" in value;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "deals" in value;

  return isInstance;
}

export function OutPublicUserWithDealsDTOFromJSON(json: any): OutPublicUserWithDealsDTO {
  return OutPublicUserWithDealsDTOFromJSONTyped(json, false);
}

export function OutPublicUserWithDealsDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutPublicUserWithDealsDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    role: UserRoleDTOFromJSON(json["role"]),
    company: !exists(json, "company") ? undefined : json["company"],
    firstName: !exists(json, "firstName") ? undefined : json["firstName"],
    lastName: !exists(json, "lastName") ? undefined : json["lastName"],
    email: json["email"],
    phone: !exists(json, "phone") ? undefined : json["phone"],
    id: json["id"],
    deals: (json["deals"] as Array<any>).map(OutDealDTOFromJSON)
  };
}

export function OutPublicUserWithDealsDTOToJSON(value?: OutPublicUserWithDealsDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    role: UserRoleDTOToJSON(value.role),
    company: value.company,
    firstName: value.firstName,
    lastName: value.lastName,
    email: value.email,
    phone: value.phone,
    id: value.id,
    deals: (value.deals as Array<any>).map(OutDealDTOToJSON)
  };
}
